import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#070414",
    },
    secondary: {
      main: "#D4D4D4",
    },
    info: {
      main: "#5D6DD8",
    },
    error: {
      main: "#FAA0A0",
    },
    success: {
      main: "#a0e7a0",
    },
  },
});
